/**
 * Resource Hub Filters
 * Handles filtering functionality for resource cards
 */

class ResourceHubFilters {
  constructor() {
    this.filterButtons = document.querySelectorAll(".resource-filter-btn");
    this.resourceCards = document.querySelectorAll(".resource-card");
    this.currentFilter = "all";

    this.init();
  }

  init() {
    if (this.filterButtons.length === 0 || this.resourceCards.length === 0) {
      return;
    }

    this.bindEvents();
    this.setInitialState();
  }

  bindEvents() {
    this.filterButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const filter = button.getAttribute("data-filter");
        this.filterResources(filter);
        this.updateActiveButton(button);
      });
    });
  }

  setInitialState() {
    // Set first button as active if no active button exists
    if (!document.querySelector(".resource-filter-btn.active")) {
      const firstButton = document.querySelector(".resource-filter-btn");
      if (firstButton) {
        firstButton.classList.add("active");
        this.currentFilter = firstButton.getAttribute("data-filter");
      }
    }
  }

  filterResources(filter) {
    this.currentFilter = filter;

    // Add filtering class to all cards for animation
    this.resourceCards.forEach((card) => {
      card.classList.add("filtering");
    });

    // Small delay for animation
    setTimeout(() => {
      this.resourceCards.forEach((card) => {
        const cardCategory = card.getAttribute("data-category");
        const shouldShow = filter === "all" || cardCategory === filter;

        if (shouldShow) {
          card.classList.remove("hidden", "filtering");
          card.classList.add("showing");
        } else {
          card.classList.add("hidden");
          card.classList.remove("showing", "filtering");
        }
      });

      // Remove filtering class after animation
      setTimeout(() => {
        this.resourceCards.forEach((card) => {
          card.classList.remove("filtering");
        });
      }, 300);
    }, 50);

    // Update URL parameter for deep linking (optional)
    this.updateURL(filter);

    // Track analytics if available
    this.trackFilterEvent(filter);
  }

  updateActiveButton(activeButton) {
    this.filterButtons.forEach((button) => {
      button.classList.remove("active");
    });
    activeButton.classList.add("active");
  }

  updateURL(filter) {
    if (typeof window.history !== "undefined" && window.history.pushState) {
      const url = new URL(window.location);

      if (filter === "all") {
        url.searchParams.delete("filter");
      } else {
        url.searchParams.set("filter", filter);
      }

      window.history.pushState({ filter }, "", url);
    }
  }

  trackFilterEvent(filter) {
    // Track filter usage with analytics if available
    if (typeof gtag !== "undefined") {
      gtag("event", "resource_filter", {
        filter_category: filter,
        page_title: document.title,
      });
    }

    // Track with Shopify Analytics if available
    if (
      typeof window.ShopifyAnalytics !== "undefined" &&
      window.ShopifyAnalytics.lib
    ) {
      window.ShopifyAnalytics.lib.track("Resource Filter Used", {
        filter: filter,
        timestamp: new Date().toISOString(),
      });
    }
  }

  // Public method to filter programmatically
  setFilter(filter) {
    const button = document.querySelector(`[data-filter="${filter}"]`);
    if (button) {
      this.filterResources(filter);
      this.updateActiveButton(button);
    }
  }

  // Get current filter
  getCurrentFilter() {
    return this.currentFilter;
  }

  // Get visible cards count
  getVisibleCardsCount() {
    return document.querySelectorAll(".resource-card:not(.hidden)").length;
  }
}

// Initialize on DOM load
document.addEventListener("DOMContentLoaded", function () {
  window.resourceHubFilters = new ResourceHubFilters();

  // Handle URL filter parameter on page load
  const urlParams = new URLSearchParams(window.location.search);
  const urlFilter = urlParams.get("filter");

  if (urlFilter && window.resourceHubFilters) {
    window.resourceHubFilters.setFilter(urlFilter);
  }
});

// Handle browser back/forward buttons
window.addEventListener("popstate", function (event) {
  if (event.state && event.state.filter && window.resourceHubFilters) {
    window.resourceHubFilters.setFilter(event.state.filter);
  }
});

// Keyboard accessibility
document.addEventListener("keydown", function (e) {
  // Allow Enter and Space to trigger filter buttons
  if (
    (e.key === "Enter" || e.key === " ") &&
    e.target.classList.contains("resource-filter-btn")
  ) {
    e.preventDefault();
    e.target.click();
  }
});

// Export for use in other scripts if needed
if (typeof module !== "undefined" && module.exports) {
  module.exports = ResourceHubFilters;
}
